export enum SubscriptionScope {
  EVENT = "EVENT",
  COMPANY = "COMPANY",
}
